<span class="{{ _iconClass }} ph-{{ name }}"></span>
